export type Variants = 'text' | 'circular' | 'rectangular';

export const VariantClass: { [key in Variants]: string } = {
    text: 'skeleton__text',
    circular: 'skeleton__circular',
    rectangular: 'skeleton__rectangular',
};
